<!-- @TODO: It is possible to increase scalability by implementing a BaseSettings component with shared functionality and extending it.
 for specific settings. e.g. Delete User is a shared setting and can be placed into superclass-->
<template>
  <h2 class="mb-4">Profile Settings</h2>

  <div v-if="!loading">
    <user-general-info
      :email="user?.email || ''"
      :first-name="user?.firstName || ''"
      :last-name="user?.lastName || ''"
    />

    <form class="mt-5" @submit.prevent="updateUser">
      <div class="mb-3 w-25 m-auto">
        <label for="exampleInputEmail1" class="form-label fw-bold"
          >New Email</label
        >
        <input
          id="exampleInputEmail1"
          v-model="newEmail"
          type="email"
          class="form-control"
          aria-describedby="emailHelp"
        />
      </div>
      <div class="mb-3 w-25 m-auto">
        <label for="exampleInputPassword1" class="form-label fw-bold"
          >New Password</label
        >
        <input
          id="exampleInputPassword1"
          v-model="newPassword"
          type="password"
          class="form-control"
        />
      </div>
      <button
        :disabled="!newEmail && !newPassword"
        class="btn btn-primary fw-bold"
        type="submit"
      >
        Update
      </button>
    </form>
  </div>
</template>

<script lang="ts">
import UserGeneralInfo from '@/components/UserGenerallnfo.vue';
import { logout } from '@/common/utils';
import { getUser, updateCredentials } from '@/common/api';
import { defineComponent } from 'vue';
import { User } from '@/types/User';
import { handleError } from '@/common/errors';

export default defineComponent({
  name: 'UserProfileCommonSettings',

  components: {
    UserGeneralInfo,
  },

  props: {
    userType: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      user: null as User | null,
      newEmail: '',
      newPassword: '',
      loading: true,
    };
  },

  async mounted() {
    this.user = await this.getUserInfo();
  },

  methods: {
    async updateUser() {
      try {
        await updateCredentials(
          this.newEmail || String(this.user?.email),
          this.newPassword,
        );
      } catch (error: unknown) {
        handleError(error, "Failed to update user's credentials");
      }
      await logout(this.$router);
    },

    async getUserInfo(): Promise<User | null> {
      try {
        const response = await getUser();
        const user = response.data;
        this.loading = false;
        return user;
      } catch (error: unknown) {
        handleError(error, 'Failed to get user info');
        return null;
      }
    },
  },
});
</script>
